import { css } from "@emotion/css";

import { Text, mq } from "@certn/cascadia-react";
interface DataDisplayListProps {
  data: Record<string, any>[];
  title?: string;
  testID: string;
  isColumn?: boolean;
  className?: string;
  WithHeaderStyle?: boolean;
}

export function DataDisplayList(props: DataDisplayListProps) {
  const { data, title, isColumn, testID, WithHeaderStyle = false } = props;
  return (
    <div className={css(styles.wrapper, props.className)} data-testid={testID}>
      {title && (
        <Text
          className={WithHeaderStyle ? styles.header : undefined}
          style="global/heading-medium"
        >
          {title}
        </Text>
      )}
      <div>
        {data?.map((item) => (
          <div
            data-testid={item?.label}
            key={item?.label}
            className={css(
              styles.row,
              mq({
                flexDirection: ["column", isColumn ? "column" : "row"],
                gap: ["none", isColumn ? "none" : "var(--space-4)"],
              })
            )}
          >
            <Text
              className={css(
                mq({ width: [undefined, isColumn ? undefined : "160px"] })
              )}
              style="global/heading-medium"
            >
              {item?.label}
            </Text>
            <Text
              className={styles.value}
              color="text-weak"
              style="global/body-primary"
            >
              {item?.value}
            </Text>
          </div>
        ))}
      </div>
    </div>
  );
}

const styles = {
  header: css({
    borderRadius: "var(--border-radius-2)",
    padding: "var(--space-0) var(--space-3) var(--space-0) var(--space-3)",
    background: "var(--background-accent-neutral-weak)",
  }),
  wrapper: css({
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-4)",
  }),
  row: css({
    display: "flex",
    paddingTop: "var(--space-1)",
    paddingBottom: "var(--space-2-5)",
  }),
  value: css({ display: "flex", flex: "1" }),
};
